<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <!-- <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} {{aLang.user_profile}}</span> -->
        <span>Màn hình QR Code</span>
        <div class="card-header-actions">
          <a href="javascript:" @click="printQR">
            <i class="fas fa-print" style="margin-right: 5px"></i>
            <span>In QR Code</span>
          </a>
        </div>
      </div>
      <div ref="wrap" class="card-body card-body-custom">
        <div id="qr-canvas" style="position: relative">
          <img
            :src="mData.srcQr"
            alt=""
            style="max-height: 100%; border-radius: 5%"
          />
          <a href="https://trangvangdulichvietnam.vn"></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DataService from "@/service/DataService";
import mushroom from "../../../service/api/trangvang-api";
import config from "../../../config";

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        srcQr: "",
        moduleName: "QRCode", //requied
        dataDefault: {
          roles: DataService.roles,
          currentUser: {},
          qrcodeId: "",
          QRCode: "",
        },
        dialog: {
          Checkin: false,
          Qrcode: false,
          Taiapp: false,
          scan: false,
          modalUser: false,
          modalInfo: false,
        },
      },
      cssStyle: {
        bgWidth: "0px",
        bgHeight: "calc(100vh - 176px)",
        fontSizeQr: "10px",
        fontSizeLink: "10px",
        qrPosionLeft: "0px",
        iconPosionLeft: "0px",
        qrPosionTop: "0px",
        iconPosionTop: "0px",
        qrNotePositionBottom: "0px",
      },
      eventInterval: null,
      canvas: null,
      isOverRatio: false,
    };
  },
  methods: {
    checkRadioInterval() {
      this.eventInterval = setInterval(() => {
        this.checkRatio();
      }, 1000);
    },
    async fn_initDataDefault() {
      let currentUserObj = MethodService.getCurrentUser();
      this.mData.dataDefault.currentUser = currentUserObj;
      let code = currentUserObj.account;

      if (currentUserObj.roles.includes("TourAgent")) {
        const resApi = await mushroom.cong_ty_lu_hanh.listAsync({
          filters: "nguoi_quan_ly_ids=" + currentUserObj.id,
          fields: "avatar_id,giay_phep_kinh_doanh",
        });
        if (
          resApi.result &&
          resApi.result.length > 0 &&
          resApi.result[0].giay_phep_kinh_doanh &&
          resApi.result[0].giay_phep_kinh_doanh.so_giay_phep
        ) {
          code = "LH-" + resApi.result[0].giay_phep_kinh_doanh.so_giay_phep;
        }
      } else if (currentUserObj.roles.includes("SafePlace")) {
        const resApi = await mushroom.diem_den_an_toan.listAsync({
          filters: "nguoi_tao_id=" + currentUserObj.id,
          fields: "thong_tin_chung.giay_to",
        });
        if (
          resApi.result &&
          resApi.result.length > 0 &&
          resApi.result[0].thong_tin_chung &&
          resApi.result[0].thong_tin_chung.giay_to &&
          resApi.result[0].thong_tin_chung.giay_to.so_giay_to
        ) {
          code = "DD-" + resApi.result[0].thong_tin_chung.giay_to.so_giay_to;
        }
      }

      this.mData.srcQr =
        config.hostApiTrangVang +
        "api/v1/qrcode-board.jpg?rnd=" +
        new Date().getTime() +
        "&code=" +
        code +
        "&lang=vi";

      console.log(this.mData.srcQr);
    },
    calcStyle() {
      let bgHeight = this.$refs.bg.clientHeight;
      let bgWidth = bgHeight / 1.5537;
      const wrapWidth = this.$refs.wrap.offsetWidth;

      if (wrapWidth - 50 <= bgWidth) {
        bgWidth = wrapWidth - 30;
        this.cssStyle.bgHeight = bgWidth * 1.5537 + "px";
      } else {
        this.cssStyle.bgHeight = "calc(100vh - 176px)";
        bgWidth = bgHeight / 1.5537;
      }
      const qrWidth = this.$refs.qr.clientWidth;
      // const iconWidth = this.$refs.imageicon.clientWidth ;
      this.cssStyle.bgWidth = bgWidth + "px";
      this.cssStyle.qrPosionLeft = `${Math.floor((bgWidth - qrWidth) / 2)}px`;
      // this.cssStyle.iconPosionLeft = `${Math.floor((bgWidth - iconWidth) / 2)}px`;
      this.cssStyle.qrPosionTop = `${Math.floor((bgHeight - qrWidth) / 1.7)}px`;
      // this.cssStyle.iconPosionTop = `${Math.floor((bgHeight - iconWidth) / 1.65)}px`;
      this.cssStyle.qrNotePositionBottom = `calc((${bgHeight * 0.1}px / 1.2)`;
      this.cssStyle.fontSizeQr = qrWidth / 10 + "px";
      this.cssStyle.fontSizeLink = qrWidth / 18 + "px";
    },
    printQR() {
      const dualScreenLeft =
        window.screenLeft !== undefined ? window.screenLeft : window.screenX;
      const dualScreenTop =
        window.screenTop !== undefined ? window.screenTop : window.screenY;

      const width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : screen.width;
      const height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : screen.height;

      const systemZoom = width / window.screen.availWidth;
      const left = (width - 700) / 2 / systemZoom + dualScreenLeft;
      const top = (height - 700) / 2 / systemZoom + dualScreenTop;
      let wndPrint = window.open(
        "about:blank",
        "wndPrint",
        "width=700,height=800,status=no,left=" +
          left +
          ",top=" +
          top +
          ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no"
      );
      if (!wndPrint) {
        alert(
          "Tính năng in không hoạt động do trình duyệt của bạn đang chặn Popup. Hãy cho phép hiển thị Popup để sử dụng được tính năng này!"
        );
        return;
      }
      let style = wndPrint.document.createElement("style");
      style.innerHTML =
        "img { margin: 0 auto; display: block; max-width: 100%; max-height: 100%;height: 950px;border-radius: 5%;}";
      let imgDOM = document.createElement("img");
      imgDOM.src = "http:" + this.mData.srcQr;
      wndPrint.document.body.appendChild(imgDOM);
      wndPrint.document.body.appendChild(style);
      setTimeout(() => {
        wndPrint.print();
        wndPrint.focus();
      }, 800);
    },
    checkRatio() {
      const wrapWidth = this.$refs.wrap.offsetWidth;
      const wrapHeight = this.$refs.wrap.offsetHeight;
      this.isOverRatio = wrapHeight / wrapWidth > 1.43440594;
    },
  },
  created() {
    this.fn_initDataDefault();
  },
  mounted() {
    window.addEventListener("resize", this.checkRatio);
    window.addEventListener("scroll", this.checkRatio);
    window.scroll({
      top: 1,
    });
    window.scroll({
      top: 0,
    });
    this.checkRadioInterval();
  },
  destroyed() {
    window.removeEventListener("resize", this.checkRatio);
    window.removeEventListener("scroll", this.checkRatio);
    clearInterval(this.eventInterval);
  },
};
</script>

<style lang="scss" scope>
#qr-canvas {
  overflow: hidden;

  &.overRatio {
    width: 100%;
    padding-bottom: 143%;
    position: relative;

    img {
      width: 100% !important;
      height: 100% !important;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }
  }

  a {
    position: absolute;
    top: 83.5%;
    left: 30%;
    right: 30%;
    width: 42%;
    height: calc((100vh - 176px) / 55);
    overflow: hidden;
    margin: 0 auto;
    z-index: 9;
  }

  img {
    height: calc(100vh - 200px) !important;
    width: calc((100vh - 200px) / 1.43) !important;
  }
}

.img-icon-center {
  width: 10%;
  z-index: 10;
  position: absolute;
}

.qr-code {
  padding: 10px;
  background-color: #fff;
}

.qr-code img {
  margin: 0 auto;
  margin-bottom: 0px !important;
  width: 385px;
  height: 385px;
}

.card-body-custom {
  min-height: calc(100vh - 176px);
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-body-custom .mt-8 p {
  font-weight: bold;
}

.card-body-custom .qr-custom {
  width: 405px;
  height: 385px;
  position: absolute;
  top: 455px;
  left: 200px;
}

.bg-qr {
  position: fixed;
  top: 10000px;
  width: 808px !important;
  height: 1159px !important;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.text-qr-id {
  font-size: 34px;
  word-break: keep-all;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

.text-qr-link {
  color: rgb(175, 63, 37);
  font-size: 20px;
  font-style: italic;
}

.text-qr-link:hover {
  text-decoration: none;
  color: rgb(175, 63, 37);
  font-size: 20px;
}

.text-qr-note {
  position: absolute;
  text-align: center;
  bottom: 60px;
  left: 15%;
  right: 15%;
  font-style: italic;
  font-size: 30px;
  font-weight: 500;
}
</style>
